import { simpleSet } from '@r/reducers/utils';

const setCalculationModeShippingCostValue = simpleSet as
  redux.reducers.calculationMode.projects.currentProject.settings.information.shippingCost.value;

export const value = setCalculationModeShippingCostValue(
  'SET_CALCULATION_MODE_CURRENT_PROJECT_SHIPPING_COST_VALUE',
  { label: '', value: 0 }
);
